declare module FWP {
  function refresh(): void;
}

const kennisbankenHeroInit = (el: HTMLElement) => {
  const input: HTMLInputElement = el.querySelector('input');
  let timeout: any;

  input.addEventListener('keyup', (e) => {
    e.preventDefault();

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.set('search', input.value);
      window.history.replaceState(null, null, url);
      FWP.refresh();
    }, 1000);
  });
};

export default kennisbankenHeroInit;
